/* assets/size-quiz-engine.js
   Segara Romjue — Size Quiz Engine (FIXED)
   Fixes:
   - Blank inputs no longer become 0 (Number("") bug) -> prevents "always XS"
   - Brand reference supports separate TOP + BOTTOM sizes (brandRef.top / brandRef.bottom)
   - Backwards compatible with brandRef.size
*/

(function () {
  "use strict";

  // ====== DEFAULT CHART (XS/S/M/L/XL — chart can be wider than what's currently for sale) ======
  var DEFAULT_CHART = {
    unitDefault: "in",
    tolerance: { in: 0.5, cm: 1.5 },
    sizes: [
      { key: "XS", top: { bust: [32, 33.5], underbust: [26, 28] }, bottom: { waist: [25, 26], hip: [35, 36.5] } },
      { key: "S",  top: { bust: [33.5, 35], underbust: [28, 29] }, bottom: { waist: [26, 28], hip: [36.5, 38] } },
      { key: "M",  top: { bust: [35, 37], underbust: [29, 31] }, bottom: { waist: [28, 30], hip: [38, 40] } },
      { key: "L",  top: { bust: [37, 39], underbust: [31, 33] }, bottom: { waist: [30, 32], hip: [40, 42] } },
      { key: "XL", top: { bust: [39, 41], underbust: [33, 35.5] }, bottom: { waist: [32, 34], hip: [42, 44.5] } }
    ]
  };

  // ====== BRAND MAPPINGS ======
  var BRAND_MAPPINGS = {
    roxy: {
      name: "Roxy",
      confidence: "very_high",
      hasUnderbust: true,
      map: { XS: "XS", S: "S", M: "M", L: "L", XL: "XL" },
      notes: "Roxy swim sizing matches ours almost exactly.",
      ranges: {
        XS: { bust: [32, 33], underbust: [26, 28], waist: [24, 26], hip: [35, 36] },
        S: { bust: [33, 35], underbust: [28, 29], waist: [26, 28], hip: [36, 38] },
        M: { bust: [35, 37], underbust: [29, 31], waist: [28, 29], hip: [38, 39] },
        L: { bust: [37, 39], underbust: [31, 33], waist: [30, 31], hip: [40, 41] },
        XL: { bust: [39, 41], underbust: [33, 35], waist: [31, 34], hip: [41, 42] }
      }
    },

    nike: {
      name: "Nike",
      confidence: "high",
      hasUnderbust: false,
      map: { XS: "XS", S: "S", M: "M", L: "L", XL: "XL" },
      notes: "Nike aligns well XS–M; Nike XL runs a bit larger in hips than many swim charts.",
      xlAdjustment: true,
      ranges: {
        XS: { bust: [31.5, 33.5], waist: [24, 26], hip: [34.5, 36.5] },
        S: { bust: [33.5, 35.5], waist: [26, 28], hip: [36.5, 38.5] },
        M: { bust: [35.5, 37.5], waist: [28, 30], hip: [38.5, 40.5] },
        L: { bust: [37.5, 40.5], waist: [30, 33], hip: [40.5, 43.5] },
        XL: { bust: [40.5, 43.5], waist: [33, 36], hip: [43.5, 46.5] }
      }
    },

    adidas: {
      name: "adidas",
      confidence: "medium",
      hasUnderbust: false,
      map: { XS: "XS", S: "S", M: "M", L: "L", XL: "XL" },
      notes: "adidas often runs smaller at XS/S, especially in hips.",
      requiresSizingPref: true,
      ranges: {
        XS: { bust: [30, 32], waist: [24, 26], hip: [33.5, 35.5] },
        S: { bust: [32, 34], waist: [26, 28], hip: [35.5, 38] },
        M: { bust: [34, 36], waist: [28, 30.5], hip: [38, 40.5] },
        L: { bust: [36.5, 39], waist: [31, 33.5], hip: [40.5, 43.5] },
        XL: { bust: [39, 41.5], waist: [34, 37], hip: [43.5, 46.5] }
      }
    },

    speedo: {
      name: "Speedo",
      confidence: "medium",
      hasUnderbust: false,
      map: { XS: "XS", S: "S", M: "M", L: "L", XL: "XL" },
      notes: "Speedo is often designed to feel more performance-snug.",
      requiresSizingPref: true,
      fitBias: "runs_tight",
      ranges: {
        XS: { bust: [32], waist: [24], hip: [34.5] },
        S: { bust: [33, 34], waist: [25, 26], hip: [35.5, 36.5] },
        M: { bust: [35, 36], waist: [27, 28], hip: [37.5, 38.5] },
        L: { bust: [37.5, 39], waist: [29.5, 31], hip: [40, 41.5] },
        XL: { bust: [40.5, 42.5], waist: [31.5, 34.5], hip: [43, 45] }
      }
    },

    billabong: {
      name: "Billabong",
      confidence: "low_medium",
      hasUnderbust: false,
      map: { XS: "XS", S: "S", M: "M", L: "L", XL: "XL" },
      notes: "Billabong is often junior-leaning and can run smaller depending on style.",
      requiresSizingPref: true,
      fitBias: "runs_small",
      ranges: {
        XS: { bust: [30.5, 32.5], waist: [23, 25], hip: [32.5, 34.5] },
        S: { bust: [32.5, 34.5], waist: [25, 27], hip: [34.5, 36.5] },
        M: { bust: [34.5, 36.5], waist: [27, 29], hip: [36.5, 38.5] },
        L: { bust: [36.5, 38.5], waist: [29, 31], hip: [38.5, 40.5] },
        XL: { bust: [38.5, 40.5], waist: [31, 33], hip: [40.5, 42.5] }
      }
    }
  };

  // ====== UTIL ======
  function isNum(x) { return typeof x === "number" && isFinite(x); }

  // IMPORTANT FIX:
  // - Number("") === 0 (bad) -> treat empty strings as null
  function toNum(x) {
    if (x === null || x === undefined) return null;
    if (typeof x === "string") {
      var t = x.trim();
      if (!t) return null;
      // allow "34,5" -> "34.5"
      t = t.replace(",", ".");
      var n = Number(t);
      return isFinite(n) ? n : null;
    }
    var n2 = Number(x);
    return isFinite(n2) ? n2 : null;
  }

  function round1(n) { return Math.round(n * 10) / 10; }

  function normalizeSizeKey(k) {
    if (!k) return "";
    return String(k).trim().toUpperCase();
  }

  function convertUnit(val, fromUnit, toUnit) {
    if (!isNum(val)) return null;
    if (fromUnit === toUnit) return val;
    if (fromUnit === "in" && toUnit === "cm") return val * 2.54;
    if (fromUnit === "cm" && toUnit === "in") return val / 2.54;
    return val;
  }

  function normalizeMeasures(input, chart) {
    var unitIn = (input && input.unit) ? String(input.unit).toLowerCase() : (chart.unitDefault || "in");
    if (unitIn !== "in" && unitIn !== "cm") unitIn = chart.unitDefault || "in";

    var unit = chart.unitDefault || "in";

    var bust = toNum(input && input.bust);
    var underbust = toNum(input && input.underbust);
    var waist = toNum(input && input.waist);
    var hip = toNum(input && input.hip);

    return {
      unit: unit,
      bust: isNum(bust) ? convertUnit(bust, unitIn, unit) : null,
      underbust: isNum(underbust) ? convertUnit(underbust, unitIn, unit) : null,
      waist: isNum(waist) ? convertUnit(waist, unitIn, unit) : null,
      hip: isNum(hip) ? convertUnit(hip, unitIn, unit) : null
    };
  }

  function distToRange(x, range) {
    if (!isNum(x) || !range || range.length !== 2) return null;
    var min = range[0], max = range[1];
    if (x < min) return min - x;
    if (x > max) return x - max;
    return 0;
  }

  function getTol(chart) {
    var u = chart.unitDefault || "in";
    var t = chart.tolerance && chart.tolerance[u];
    if (!isNum(t) || t <= 0) return (u === "cm" ? 1.5 : 0.5);
    return t;
  }

  function chartMinMax(chart, part, key) {
    var sizes = chart.sizes || [];
    var min = null, max = null;
    for (var i = 0; i < sizes.length; i++) {
      var def = sizes[i] && sizes[i][part];
      var r = def && def[key];
      if (!r) continue;
      if (min == null || r[0] < min) min = r[0];
      if (max == null || r[1] > max) max = r[1];
    }
    return { min: min, max: max };
  }

  function outOfRangeFlags(chart, measures) {
    var tol = getTol(chart);
    var flags = [];

    var bustMM = chartMinMax(chart, "top", "bust");
    var underMM = chartMinMax(chart, "top", "underbust");

    if (isNum(measures.bust) && isNum(bustMM.min) && isNum(bustMM.max)) {
      if (measures.bust < bustMM.min - tol) flags.push("bust_low");
      if (measures.bust > bustMM.max + tol) flags.push("bust_high");
    }
    if (isNum(measures.underbust) && isNum(underMM.min) && isNum(underMM.max)) {
      if (measures.underbust < underMM.min - tol) flags.push("underbust_low");
      if (measures.underbust > underMM.max + tol) flags.push("underbust_high");
    }

    var waistMM = chartMinMax(chart, "bottom", "waist");
    var hipMM = chartMinMax(chart, "bottom", "hip");

    if (isNum(measures.waist) && isNum(waistMM.min) && isNum(waistMM.max)) {
      if (measures.waist < waistMM.min - tol) flags.push("waist_low");
      if (measures.waist > waistMM.max + tol) flags.push("waist_high");
    }
    if (isNum(measures.hip) && isNum(hipMM.min) && isNum(hipMM.max)) {
      if (measures.hip < hipMM.min - tol) flags.push("hip_low");
      if (measures.hip > hipMM.max + tol) flags.push("hip_high");
    }

    return flags;
  }

  // ====== AVAILABLE SIZE FILTERING ======
  function getAvailableList(prefs, part) {
    var list = null;

    if (prefs) {
      if (part === "top" && Array.isArray(prefs.availableTop)) list = prefs.availableTop;
      if (part === "bottom" && Array.isArray(prefs.availableBottom)) list = prefs.availableBottom;
      if (!list && Array.isArray(prefs.availableSizes)) list = prefs.availableSizes;
    }
    if (!list) return null;

    var out = [];
    for (var i = 0; i < list.length; i++) {
      var k = normalizeSizeKey(list[i]);
      if (!k) continue;
      if (out.indexOf(k) === -1) out.push(k);
    }
    return out.length ? out : null;
  }

  var SIZE_ORDER = ["XS", "S", "M", "L", "XL", "XXL"];

  function nearestAvailableSize(available, recommendedKey) {
    if (!recommendedKey) return { size: null, isExact: false };
    var rec = normalizeSizeKey(recommendedKey);

    if (!available || !available.length) {
      return { size: rec, isExact: true };
    }

    if (available.indexOf(rec) !== -1) {
      return { size: rec, isExact: true };
    }

    var recIndex = SIZE_ORDER.indexOf(rec);
    if (recIndex === -1) return { size: null, isExact: false };

    for (var step = 1; step < SIZE_ORDER.length; step++) {
      var up = recIndex + step;
      var down = recIndex - step;

      if (up < SIZE_ORDER.length && available.indexOf(SIZE_ORDER[up]) !== -1) {
        return { size: SIZE_ORDER[up], isExact: false, direction: "up" };
      }
      if (down >= 0 && available.indexOf(SIZE_ORDER[down]) !== -1) {
        return { size: SIZE_ORDER[down], isExact: false, direction: "down" };
      }
    }

    return { size: null, isExact: false };
  }

  // ====== SCORING ======
  function scoreSizeForKeys(sizeDef, measures, keys) {
    var score = 0;
    var used = 0;
    var misses = 0;
    var distances = [];

    for (var i = 0; i < keys.length; i++) {
      var k = keys[i];
      var x = measures[k];
      var range = sizeDef[k];

      if (!range) continue;

      if (!isNum(x)) {
        misses += 1;
        continue;
      }

      used += 1;
      var d = distToRange(x, range);
      if (d == null) continue;

      if (d === 0) score += 100;
      else score += (60 - (d * 8));

      distances.push(d);
    }

    score -= misses * 35;
    score += used * 8;

    if (distances.length) {
      var sum = 0;
      for (var j = 0; j < distances.length; j++) sum += distances[j];
      var avg = sum / distances.length;
      score -= avg * 6;
    }

    return { score: score, used: used, misses: misses, distances: distances };
  }

  function pickBestAndSecond(chart, measures, part) {
    var sizes = chart.sizes || [];
    var keys = (part === "top") ? ["bust", "underbust"] : ["waist", "hip"];

    var best = null;
    var second = null;

    for (var i = 0; i < sizes.length; i++) {
      var s = sizes[i];
      var def = s && s[part];
      if (!def) continue;

      var r = scoreSizeForKeys(def, measures, keys);
      var total = r.score;
      var candidate = { key: normalizeSizeKey(s.key), idx: i, total: total, raw: r, def: def };

      if (!best || total > best.total) {
        second = best;
        best = candidate;
      } else if (!second || total > second.total) {
        second = candidate;
      }
    }

    return { best: best, second: second };
  }

  function computeConfidence(chart, best) {
    if (!best) return { level: "low", reason: "no_match" };

    var tol = getTol(chart);
    var used = best.raw.used;
    var misses = best.raw.misses;

    if (used === 0) return { level: "low", reason: "insufficient_input" };

    var maxD = 0;
    for (var i = 0; i < best.raw.distances.length; i++) {
      if (best.raw.distances[i] > maxD) maxD = best.raw.distances[i];
    }

    if (used >= 2 && misses === 0) {
      if (maxD === 0) return { level: "high", reason: "in_range" };
      if (maxD <= tol) return { level: "medium", reason: "near_range" };
      return { level: "low", reason: "out_of_range" };
    }

    if (used === 1) {
      if (maxD === 0) return { level: "medium", reason: "partial_in_range" };
      if (maxD <= tol) return { level: "medium", reason: "partial_near" };
      return { level: "low", reason: "partial_out" };
    }

    return { level: "low", reason: "insufficient_input" };
  }

  function clampIfExtreme(chart, candidate, measures, part, notes) {
    var tol = getTol(chart);
    var primaryKey = (part === "top") ? "bust" : "hip";
    var mm = chartMinMax(chart, part, primaryKey);

    if (!isNum(measures[primaryKey]) || !isNum(mm.min) || !isNum(mm.max)) return candidate;

    var x = measures[primaryKey];

    if (x < mm.min - tol) {
      if (notes) notes.push("A measurement looks outside our chart — please double-check inches vs cm. We’ll recommend the closest size we can.");
      return { key: normalizeSizeKey(chart.sizes[0].key), idx: 0, total: candidate ? candidate.total : 0, raw: candidate ? candidate.raw : { used: 0, misses: 0, distances: [] }, def: chart.sizes[0][part] };
    }

    if (x > mm.max + tol) {
      var last = chart.sizes.length - 1;
      if (notes) notes.push("A measurement looks outside our chart — please double-check inches vs cm. We’ll recommend the closest size we can.");
      return { key: normalizeSizeKey(chart.sizes[last].key), idx: last, total: candidate ? candidate.total : 0, raw: candidate ? candidate.raw : { used: 0, misses: 0, distances: [] }, def: chart.sizes[last][part] };
    }

    return candidate;
  }

  // ====== BETWEEN-SIZE ("also works") ======
  function shouldOfferAlt(best, second) {
    if (!best || !second) return false;
    if (best.key === second.key) return false;
    var bi = SIZE_ORDER.indexOf(best.key);
    var si = SIZE_ORDER.indexOf(second.key);
    if (bi === -1 || si === -1) return false;
    if (Math.abs(bi - si) !== 1) return false;
    var delta = best.total - second.total;
    return delta <= 12;
  }

  function altReason(bestKey, altKey, fitPref) {
    var base = "You’re right near the line between " + bestKey + " and " + altKey + ".";
    if (fitPref === "more_secure") return base + " If you like a slightly more secure feel, choose " + bestKey + ".";
    if (fitPref === "more_minimal") return base + " If you like a slightly less snug feel, " + altKey + " can also work.";
    return base + " Most customers will feel best staying true-to-size (" + bestKey + ").";
  }

  // ====== BRAND HELPERS ======
  function checkMeasurementFitInBrandRange(measures, brandKey, brandSize) {
    var mapping = BRAND_MAPPINGS[brandKey];
    if (!mapping || !mapping.ranges || !mapping.ranges[brandSize]) {
      return { fits: null, details: {} };
    }

    var brandRanges = mapping.ranges[brandSize];
    var details = { bust: null, underbust: null, waist: null, hip: null };
    var allFit = true;

    if (isNum(measures.bust) && brandRanges.bust) {
      var bustFits = measures.bust >= brandRanges.bust[0] && measures.bust <= brandRanges.bust[1];
      details.bust = bustFits;
      if (!bustFits) allFit = false;
    }

    if (isNum(measures.underbust) && brandRanges.underbust) {
      var underFits = measures.underbust >= brandRanges.underbust[0] && measures.underbust <= brandRanges.underbust[1];
      details.underbust = underFits;
      if (!underFits) allFit = false;
    }

    if (isNum(measures.waist) && brandRanges.waist) {
      var waistFits = measures.waist >= brandRanges.waist[0] && measures.waist <= brandRanges.waist[1];
      details.waist = waistFits;
      if (!waistFits) allFit = false;
    }

    if (isNum(measures.hip) && brandRanges.hip) {
      var hipFits = measures.hip >= brandRanges.hip[0] && measures.hip <= brandRanges.hip[1];
      details.hip = hipFits;
      if (!hipFits) allFit = false;
    }

    return { fits: allFit, details: details };
  }

  // Backward compatible:
  // - brandRef.size => applies to both
  // - brandRef.top and/or brandRef.bottom => separate sizes
  function normalizeBrandRef(brandRef) {
    if (!brandRef) return null;
    var brand = brandRef.brand ? String(brandRef.brand).toLowerCase() : "";
    if (!brand) return null;

    var sizeBoth = brandRef.size ? normalizeSizeKey(brandRef.size) : "";
    var top = brandRef.top ? normalizeSizeKey(brandRef.top) : "";
    var bottom = brandRef.bottom ? normalizeSizeKey(brandRef.bottom) : "";

    if (sizeBoth) {
      top = top || sizeBoth;
      bottom = bottom || sizeBoth;
    }

    return {
      brand: brand,
      top: top || "",
      bottom: bottom || "",
      sizingPref: brandRef.sizingPref ? String(brandRef.sizingPref) : ""
    };
  }

  function recommendFromBrandOnlySplit(brandKey, topSize, bottomSize, sizingPref) {
    brandKey = String(brandKey || "").toLowerCase();

    var mapping = BRAND_MAPPINGS[brandKey];
    if (!mapping) {
      return {
        topSize: null, bottomSize: null,
        topAlt: null, bottomAlt: null,
        confidence: "low",
        notes: ["Brand not recognized."],
        method: "brand_only"
      };
    }

    var tKey = topSize ? normalizeSizeKey(topSize) : "";
    var bKey = bottomSize ? normalizeSizeKey(bottomSize) : "";

    var tMapped = tKey ? mapping.map[tKey] : null;
    var bMapped = bKey ? mapping.map[bKey] : null;

    if (!tMapped && !bMapped) {
      return {
        topSize: null, bottomSize: null,
        topAlt: null, bottomAlt: null,
        confidence: "low",
        notes: ["Size not found in brand mapping."],
        method: "brand_only"
      };
    }

    var notes = [];
    notes.unshift("Brand-only sizing is a quick estimate. Measurements are the most accurate.");
    notes.push(mapping.notes);

    if (mapping.fitBias === "runs_tight" || mapping.fitBias === "runs_small") {
      if (sizingPref === "size_up") {
        notes.push(mapping.name + " can feel snug for some people. Since you typically size up, we’ll keep you aligned to your usual labeled size.");
      } else {
        notes.push(mapping.name + " can feel snug for some people. If your usual size feels tight in that brand, consider the next size up here.");
      }
    }

    if (brandKey === "nike" && (tKey === "XL" || bKey === "XL")) {
      notes.push("Nike XL can run roomier in hips than some swim charts. If you’re at the smaller end of Nike XL, L may feel closer here.");
    }

    var conf = (mapping.confidence === "very_high") ? "medium" : "low";

    return {
      topSize: tMapped || bMapped,       // if user only gave bottom, reuse for top estimate
      bottomSize: bMapped || tMapped,    // if user only gave top, reuse for bottom estimate
      topAlt: null,
      bottomAlt: null,
      confidence: conf,
      notes: notes,
      method: "brand_only",
      brandName: mapping.name,
      brandTop: tKey || null,
      brandBottom: bKey || null
    };
  }

  // ====== PROPERTIES ======
  function buildProperties(result, rawInput, prefs, brandRefNorm) {
    var props = {};
    props["_Size Quiz"] = "Top: " + (result.topSize || "") + " / Bottom: " + (result.bottomSize || "");
    if (result.topAlt || result.bottomAlt) {
      props["_Size Quiz Alt"] = "Top alt: " + (result.topAlt || "-") + " / Bottom alt: " + (result.bottomAlt || "-");
    }

    props["_Quiz Confidence"] = String(result.confidence || "medium");
    props["_Quiz Method"] = String(result.method || "measurement_only");

    if (result.notes && result.notes.length) props["_Quiz Notes"] = result.notes.join(" ");

    var u = (rawInput && rawInput.unit) ? String(rawInput.unit) : "in";
    var parts = [];
    if (rawInput && rawInput.bust != null && String(rawInput.bust).trim() !== "") parts.push("Bust: " + rawInput.bust + u);
    if (rawInput && rawInput.underbust != null && String(rawInput.underbust).trim() !== "") parts.push("Underbust: " + rawInput.underbust + u);
    if (rawInput && rawInput.waist != null && String(rawInput.waist).trim() !== "") parts.push("Waist: " + rawInput.waist + u);
    if (rawInput && rawInput.hip != null && String(rawInput.hip).trim() !== "") parts.push("Hip: " + rawInput.hip + u);
    if (parts.length) props["_Quiz Inputs"] = parts.join(", ");

    if (brandRefNorm && brandRefNorm.brand) {
      var br = brandRefNorm.brand;
      var t = brandRefNorm.top ? (" top:" + brandRefNorm.top) : "";
      var b = brandRefNorm.bottom ? (" bottom:" + brandRefNorm.bottom) : "";
      props["_Brand Reference"] = br + (t || b ? (" (" + (t + (t && b ? "," : "") + b).trim() + ")") : "");
    }

    if (prefs && prefs.secure) props["_Quiz Fit Pref"] = String(prefs.secure);

    if (prefs && (prefs.availableTop || prefs.availableBottom || prefs.availableSizes)) {
      var av = prefs.availableTop || prefs.availableBottom || prefs.availableSizes;
      props["_Quiz Available Sizes"] = Array.isArray(av) ? av.join(",") : String(av);
    }

    props["_Quiz Version"] = "v3.3";
    return props;
  }

  // ====== MAIN RECOMMEND ======
  function recommend(chart, input, prefs, brandRef) {
    var c = (chart && chart.sizes) ? chart : DEFAULT_CHART;
    var measures = normalizeMeasures(input || {}, c);
    var notes = [];

    var hasMeasurements =
      isNum(measures.bust) || isNum(measures.underbust) || isNum(measures.waist) || isNum(measures.hip);

    var br = normalizeBrandRef(brandRef);

    // Brand-only path (no measurements)
    if (!hasMeasurements && br && br.brand && (br.top || br.bottom)) {
      var bOnly = recommendFromBrandOnlySplit(br.brand, br.top, br.bottom, br.sizingPref);
      bOnly.properties = buildProperties(bOnly, input || {}, prefs || {}, br);
      bOnly.propertiesTop = bOnly.properties;
      bOnly.propertiesBottom = bOnly.properties;
      return bOnly;
    }

    if (!hasMeasurements) {
      return {
        topSize: null, bottomSize: null,
        topAlt: null, bottomAlt: null,
        confidence: "low",
        notes: ["Please enter a measurement (approx is fine) or choose a brand reference."],
        method: "none"
      };
    }

    // Gentle range check
    var flags = outOfRangeFlags(c, measures);
    if (flags.length) {
      notes.push("A measurement looks outside our chart — please double-check inches vs cm. We’ll still recommend the closest size we can.");
    }

    // Pick best + second for each part
    var topPick = pickBestAndSecond(c, measures, "top");
    var botPick = pickBestAndSecond(c, measures, "bottom");

    var topBest = clampIfExtreme(c, topPick.best, measures, "top", notes);
    var botBest = clampIfExtreme(c, botPick.best, measures, "bottom", notes);

    // Available sizes
    var availTop = getAvailableList(prefs || {}, "top");
    var availBot = getAvailableList(prefs || {}, "bottom");

    var topAvail = nearestAvailableSize(availTop, topBest ? topBest.key : null);
    var botAvail = nearestAvailableSize(availBot, botBest ? botBest.key : null);

    // Optional alt
    var fitPref = (prefs && prefs.secure) ? String(prefs.secure) : "true_to_size";

    var topAlt = null, topAltReason = null;
    if (shouldOfferAlt(topPick.best, topPick.second)) {
      var mappedAltTop = nearestAvailableSize(availTop, topPick.second.key);
      if (mappedAltTop && mappedAltTop.size && mappedAltTop.size !== topAvail.size) {
        topAlt = mappedAltTop.size;
        topAltReason = altReason(topAvail.size, topAlt, fitPref);
      }
    }

    var botAlt = null, botAltReason = null;
    if (shouldOfferAlt(botPick.best, botPick.second)) {
      var mappedAltBot = nearestAvailableSize(availBot, botPick.second.key);
      if (mappedAltBot && mappedAltBot.size && mappedAltBot.size !== botAvail.size) {
        botAlt = mappedAltBot.size;
        botAltReason = altReason(botAvail.size, botAlt, fitPref);
      }
    }

    // Confidence
    var topConf = computeConfidence(c, topBest);
    var botConf = computeConfidence(c, botBest);

    var confidence = "medium";
    if (topConf.level === "low" || botConf.level === "low") confidence = "low";
    if (topConf.level === "high" && botConf.level === "high") confidence = "high";

    if ((topAvail && topAvail.isExact === false) || (botAvail && botAvail.isExact === false)) {
      confidence = "medium";
    }

    // Notes for fallback remap
    if (topAvail && topAvail.isExact === false && topBest && topBest.key) {
      notes.unshift("Your ideal top size would be " + topBest.key + ", but the closest available size is " + topAvail.size + ".");
    }
    if (botAvail && botAvail.isExact === false && botBest && botBest.key) {
      notes.unshift("Your ideal bottom size would be " + botBest.key + ", but the closest available size is " + botAvail.size + ".");
    }

    if (topAltReason) notes.push(topAltReason);
    if (botAltReason) notes.push(botAltReason);

    // Missing input guidance
    if (!isNum(measures.bust) && !isNum(measures.underbust)) notes.push("For best top accuracy, add bust + underbust.");
    else if (!isNum(measures.bust)) notes.push("For best top accuracy, add bust.");
    else if (!isNum(measures.underbust)) notes.push("For best top accuracy, add underbust.");

    if (!isNum(measures.waist) && !isNum(measures.hip)) notes.push("For best bottom accuracy, add waist + hip.");
    else if (!isNum(measures.waist)) notes.push("For best bottom accuracy, add waist.");
    else if (!isNum(measures.hip)) notes.push("For best bottom accuracy, add hip.");

    // Brand validation (measurements + brand) — supports separate top/bottom brand sizes
    var method = (br && br.brand && (br.top || br.bottom)) ? "measurement_with_brand" : "measurement_only";

    if (br && br.brand) {
      var mapping = BRAND_MAPPINGS[br.brand];
      if (mapping) {
        var topMsgDone = false;
        var botMsgDone = false;

        // TOP validation (if provided)
        if (br.top) {
          var expectedTop = mapping.map[br.top] || null;
          var topMatches = expectedTop ? (topBest && topBest.key === expectedTop) : false;
          var fitCheckTop = checkMeasurementFitInBrandRange(measures, br.brand, br.top);

          if (topMatches) {
            notes.unshift("Top confirmed: your measurements align well with your " + mapping.name + " " + br.top + ".");
            topMsgDone = true;
          } else if (fitCheckTop.fits === false) {
            notes.push("Top note: your measurements don’t line up with " + mapping.name + " " + br.top + " on their chart — we’re prioritizing your measurements for this recommendation.");
            topMsgDone = true;
          }
        }

        // BOTTOM validation (if provided)
        if (br.bottom) {
          var expectedBot = mapping.map[br.bottom] || null;
          var botMatches = expectedBot ? (botBest && botBest.key === expectedBot) : false;
          var fitCheckBot = checkMeasurementFitInBrandRange(measures, br.brand, br.bottom);

          if (botMatches) {
            notes.unshift("Bottom confirmed: your measurements align well with your " + mapping.name + " " + br.bottom + ".");
            botMsgDone = true;
          } else if (fitCheckBot.fits === false) {
            notes.push("Bottom note: your measurements don’t line up with " + mapping.name + " " + br.bottom + " on their chart — we’re prioritizing your measurements for this recommendation.");
            botMsgDone = true;
          }
        }

        // If brand provided but neither message triggered, include general note
        if ((br.top || br.bottom) && !topMsgDone && !botMsgDone) {
          notes.push(mapping.notes);
        }
      }
    }

    // De-duplicate notes
    if (notes.length) {
      var seen = {};
      notes = notes.filter(function (t) {
        if (!t) return false;
        if (seen[t]) return false;
        seen[t] = true;
        return true;
      });
    }

    var result = {
      unit: c.unitDefault || "in",

      topSize: topAvail ? topAvail.size : (topBest ? topBest.key : null),
      bottomSize: botAvail ? botAvail.size : (botBest ? botBest.key : null),

      topAlt: topAlt,
      bottomAlt: botAlt,

      topSizeIdeal: topBest ? topBest.key : null,
      bottomSizeIdeal: botBest ? botBest.key : null,
      topSizeFallback: topAvail ? !topAvail.isExact : false,
      bottomSizeFallback: botAvail ? !botAvail.isExact : false,

      confidence: confidence,
      notes: notes,
      method: method,

      debug: {
        normalized: {
          unit: measures.unit,
          bust: isNum(measures.bust) ? round1(measures.bust) : null,
          underbust: isNum(measures.underbust) ? round1(measures.underbust) : null,
          waist: isNum(measures.waist) ? round1(measures.waist) : null,
          hip: isNum(measures.hip) ? round1(measures.hip) : null
        },
        top: topBest ? { key: topBest.key, score: round1(topBest.total), used: topBest.raw.used, misses: topBest.raw.misses } : null,
        bottom: botBest ? { key: botBest.key, score: round1(botBest.total), used: botBest.raw.used, misses: botBest.raw.misses } : null,
        topSecond: topPick.second ? { key: topPick.second.key, score: round1(topPick.second.total) } : null,
        bottomSecond: botPick.second ? { key: botPick.second.key, score: round1(botPick.second.total) } : null,
        availableTop: availTop || null,
        availableBottom: availBot || null,
        brandRef: br || null
      }
    };

    result.properties = buildProperties(result, input || {}, prefs || {}, br);
    result.propertiesTop = result.properties;
    result.propertiesBottom = result.properties;

    return result;
  }

  // ====== INTEGRATION HELPERS ======
  function applyToSetBuilder(targetSelector, result) {
    if (!targetSelector || !result) return;
    window.dispatchEvent(new CustomEvent("sizequiz:apply", {
      detail: {
        target: String(targetSelector),
        topSize: result.topSize,
        bottomSize: result.bottomSize,
        topAlt: result.topAlt || null,
        bottomAlt: result.bottomAlt || null,
        properties: result.properties,
        propertiesTop: result.propertiesTop,
        propertiesBottom: result.propertiesBottom
      }
    }));
  }

  // ====== EXPORTS ======
  window.SizeQuizEngine = {
    DEFAULT_CHART: DEFAULT_CHART,
    BRAND_MAPPINGS: BRAND_MAPPINGS,
    recommend: recommend,
    applyToSetBuilder: applyToSetBuilder
  };
})();
